/** zh-CN catalogue `library` (W3-09; English: src/features/library/library.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'library',
  locale: 'zh-CN',
  messages: {
    appName: 'Phiedit',
    searchLabel: '搜索谱面',
    searchPlaceholder: '按曲名、曲师或等级搜索',
    help: '帮助',
    settings: '设置',
    startLabel: '开始',
    startNewTitle: '新建谱面',
    startNewBody: '从一首曲目开始',
    startOpenTitle: '打开谱面文件',
    startOpenBody: '.pez .zip 文件夹 .json .pec',
    startSampleTitle: '用示例来学习',
    startSampleBody: '2 分钟引导式导览',
    startUnavailable: '此版本中不可用',
    dropHint: '也可以将曲目、谱面、谱面包或皮肤拖放到此页面的任意位置。',
    yourCharts: '我的谱面',
    chartCount: '{count, plural, other {# 张谱面}}',
    groupBySong: '按曲目分组',
    sortLabel: '排序',
    sortEdited: '最近编辑',
    sortOpened: '最近打开',
    sortCreated: '最新创建',
    sortName: '曲名',
    sortDifficulty: '难度',
    viewLabel: '视图',
    viewGrid: '网格',
    viewList: '列表',
    emptyTitle: '还没有谱面',
    emptyBody: '从一首曲目新建谱面、打开谱面文件，或用示例来学习。',
    noMatchTitle: '没有与“{query}”匹配的谱面',
    noMatchBody: '搜索会查找曲名、曲师和等级。',
    clearSearch: '清除搜索',
    loading: '正在加载谱面…',
    loadFailed: '无法列出谱面：{reason}',
    retry: '重试',
    listLabel: '谱面',
    keyboardHint: '方向键移动，Enter 打开，F2 重命名，Delete 移入回收站，直接输入即可搜索。',
    songShared: '{count, plural, other {# 个难度共用这首曲目}}',
    songGroupLabel: '曲目 {title}',
    unknownComposer: '未知曲师',
    untitled: '未命名谱面',
    noLevel: '无等级',
    stats: '{notes, plural, other {# 个音符}} · {lines, plural, other {# 条判定线}}',
    edited: '{when}编辑',
    editedJustNow: '刚刚编辑',
    justNow: '刚刚',
    changedSinceExport: '导出后有更改',
    neverExported: '尚未导出',
    exported: '{when}导出',
    recovered: '已恢复未保存的编辑',
    recoveredTip: '此谱面打开时 Phiedit 被关闭了。已从日志中恢复其最新的编辑：没有丢失任何内容。',
    cardLabel: '{name}，{level}。{stats}。{edited}。{flags}。',
    thumbnailAlt: '{name} 的曲绘',
    menuLabel: '{name} 的操作',
    actOpen: '打开',
    actNewDifficulty: '新建难度（共用曲目）…',
    actDuplicate: '创建副本',
    actExport: '导出 .pez',
    actVersions: '版本历史',
    actRename: '重命名',
    actRecovery: '下载恢复数据',
    actTrash: '移入回收站（30 天内可恢复）',
    renameLabel: '谱面标题',
    renameEmpty: '谱面需要一个标题。',
    renamed: '已重命名为“{name}”。',
    renameTxn: '将谱面重命名为“{name}”',
    duplicated: '已创建“{name}”。',
    copyName: '{name}（副本）',
    trashed: '已将“{name}”移入回收站。它会保留 30 天。',
    restore: '恢复',
    restored: '已恢复“{name}”。',
    inOtherTab: '“{name}”已在另一个标签页中打开。请先在那里关闭它。',
    notFound: '此谱面已不存在。',
    quota: '浏览器中已没有可供 Phiedit 使用的空间。请释放一些空间，或删除不再需要的谱面。',
    actionFailed: '操作失败：{reason}',
    openFailed: '无法打开“{name}”：{reason}',
    recoverySaved: '已下载“{name}”的恢复数据。',
    recoveryFileName: '{name} 恢复数据 {date}',
    open: '打开',
    busy: '正在处理…',
    dismiss: '关闭',
    exportOpening: '正在打开“{name}”以导出…',
    trashTitle: '回收站',
    trashBack: '谱面库',
    trashIntro: '回收站中的谱面会在 30 天后被永久删除。恢复谱面即可再次编辑。',
    trashEmptyTitle: '回收站是空的',
    trashEmptyBody: '移入回收站的谱面会在这里保留 30 天。',
    trashDaysLeft: '{days, plural, =0 {今天删除} other {# 天后删除}}',
    trashedAt: '{when}移入回收站',
    deleteForever: '永久删除',
    emptyTrash: '清空回收站',
    deleteOneTitle: '永久删除“{name}”？',
    deleteManyTitle: '永久删除 {count} 张谱面？',
    deleteBody: '此操作无法撤销。没有其他谱面使用的文件也会被移除。',
    deleteConfirm: '永久删除',
    deleted: '{count, plural, other {已永久删除 # 张谱面。}}',
    trashListLabel: '回收站中的谱面',
    storageLabel: '存储',
    storageLoading: '正在检查存储…',
    storageUnknown: '此浏览器无法显示存储用量。',
    sizeB: '{size} B',
    sizeKB: '{size} KB',
    sizeMB: '{size} MB',
    sizeGB: '{size} GB',
    sizeTB: '{size} TB',
    usage: '已使用 {used}，共 {quota}',
    usageUnknown: '已使用 {used}',
    protectedLine: '已防止被自动清理',
    notProtected: '未受保护：空间不足时浏览器可能会删除你的谱面。',
    protect: '保护我的谱面',
    protectGranted: '你的谱面现在不会被自动清理了。',
    protectDenied: '浏览器不允许这样做。请不时下载备份以确保安全。',
    lowSpace: '可用空间不足 200 MB：Phiedit 可能很快就无法保存。',
    writeError: '上次保存失败：{reason}',
    trashLink: '回收站（{count}）',
    backup: '全部下载为备份',
    backupProgress: '正在准备备份',
    backupDone: '{count, plural, other {已下载备份：# 张谱面。}}',
    backupFailed: '无法创建备份：{reason}',
    backupNothing: '还没有可备份的谱面。',
    backupFileName: 'Phiedit 备份 {date}',
    opfsOff: '媒体文件保存在浏览器数据库中（此浏览器没有私有文件系统）。',
    recoveryTitle: '{count, plural, other {有 # 张谱面没有正常关闭}}',
    recoveryBody: 'Phiedit 已从日志中恢复了它们最新的编辑。没有丢失任何内容：打开谱面即可继续。',
    recoveryOpen: '打开“{name}”',
    importing: '正在导入',
    ndTitle: '“{name}”的新难度',
    ndDescription: '新谱面共用曲目和曲绘。速度、偏移和曲目信息会被复制。',
    ndStart: '开始方式',
    ndEmpty: '从空白开始',
    ndEmptyHelp: '没有判定线和音符：从头开始制作这个难度。',
    ndCopy: '复制此谱面',
    ndCopyHelp: '判定线、音符和运动都会被复制：再为新难度修改它们。',
    ndLabel: '难度标签',
    ndLabelOther: '其他',
    ndCustomLabel: '自定义标签',
    ndNumber: '等级',
    ndPreview: '显示为 {level}',
    ndCreate: '创建并打开',
    ndCancel: '取消',
    ndCreating: '正在创建…',
    ndCreated: '已创建“{name}”的 {level}。',
    ndExisting: '这首曲目已有：{levels}',
    ndLabelTaken: '这首曲目已有一张 {label} 谱面。你仍然可以再创建一张。',
    ndNumberInvalid: '请输入 {min} 到 {max} 之间的等级，步长为 0.1。',
    leTitle: '“{name}”已在另一个标签页中打开',
    leBody: '同一时间只能在一个标签页中编辑谱面，这样两个标签页的更改永远不会混在一起。',
    leSwitch: '切换到该标签页',
    leSwitchHelp: '在另一个标签页中继续编辑。',
    leEditHere: '改为在此处编辑',
    leEditHereHelp: '另一个标签页会保存并关闭谱面，然后返回它的谱面库。',
    leTakingOver: '正在请求另一个标签页保存并关闭谱面…',
    leSwitched:
      'Phiedit 已请求另一个标签页切换到前台。如果浏览器没有切换，请在标签栏中选择显示“{name}”的 Phiedit 标签页。',
    leFailed: '另一个标签页没有交出谱面。请在那里关闭它，然后重试。',
    leCancel: '取消',
    titleBlink: '在这里：{name}',
    focusRequested: '“{name}”正在此标签页中编辑。另一个标签页请求切换到这里。',
    cmdOpen: '打开谱面',
    cmdNewDifficulty: '新建难度…',
    cmdDuplicate: '创建谱面副本',
    cmdExport: '将谱面导出为 .pez',
    cmdRename: '重命名谱面…',
    cmdTrash: '将谱面移入回收站',
    cmdRestore: '从回收站恢复谱面',
    cmdDeleteForever: '永久删除谱面',
    cmdEmptyTrash: '清空回收站',
    cmdShowTrash: '显示回收站',
    cmdBackupAll: '将所有谱面下载为备份',
    cmdProtect: '保护我的谱面不被自动清理',
    cmdRecovery: '下载恢复数据',
    noTarget: '请先在谱面库中选择一张谱面。',
    notInTrash: '“{name}”不在回收站中。',
    deleteNeedsTrash: '请先将谱面移入回收站。只能从回收站中永久删除谱面。',
    renameArg: '新标题',
    trashOpenChart: '请先关闭谱面，再将其移入回收站。',
    helpLibraryTitle: '你的谱面与谱面库',
    helpLibraryBody:
      '谱面库按曲目分组列出此浏览器中的所有谱面：使用同一曲目文件的谱面是同一首曲目的不同难度。按 Enter 或单击即可打开谱面。卡片菜单可以新建难度（共用曲目和曲绘，并复制速度、偏移和曲目信息）、创建副本、导出、重命名，或将谱面移入回收站，它会在那里保留 30 天。同一时间只能在一个标签页中编辑谱面：如果它已在别处打开，可以选择切换到那个标签页，或改为在此处编辑。',
    helpBackupTitle: '保护你的谱面',
    helpBackupBody:
      '你工作时每次更改都会保存在此浏览器中，版本还能让你回到过去。但空间不足时浏览器仍可能清除网站数据：请使用谱面库底部的“保护我的谱面”，并不时使用“全部下载为备份”。备份以 .pez 谱面包的形式保存每张谱面，并附带其 phiedit.json 文件。',
    importStageChart: '正在读取谱面…',
    importStageCheck: '正在检查谱面…',
    importStageConvert: '正在转换谱面…',
    importStageFiles: '正在读取曲目和图片…',
    importStageManifest: '正在读取谱面包信息…',
    importStageSave: '正在保存项目…',
    importStageAt: '{stage} {file}',
    importStageUnpack: '正在解压文件…',
    nextStepTitle: '从这里开始',
    nextStepBody:
      '“用示例来学习”会打开一张现成的谱面，并用约 2 分钟带你熟悉编辑器。准备好后，“新建谱面”可以从你自己的曲目开始。',
    nextStepDismiss: '隐藏此提示',
  },
};

export default catalog;
